// El ÚNICO módulo del front que mira el entorno. Ver
// control-room/harness/conventions/comportamiento-por-entorno.md
//
// El entorno sale de window.__CONFIG__, que escribe el contenedor en cada arranque
// (docker-entrypoint.sh) desde el .env de su entorno: la demo la decide el deploy.
// Antes se decidía mirando si el sitio corría dentro de un iframe, y eso lo decide
// quien embebe —o quien no—.
const config = window.__CONFIG__ || {}

export const EN_DEMO = config.entorno === "demo"

export const MSG_DEMO = "No disponible en la demo"

// Lo que sí se escribe en la demo: login, reservar un turno y cancelar el propio. Cancelar tiene que
// estar, porque la app no deja reservar con un turno pendiente y la cuenta de prueba es compartida.
// El corte de verdad lo hace el back (figure-api/src/utils/demo.js): esto solo evita el viaje y da
// un mensaje claro.
const ESCRITURAS_PERMITIDAS = [
    "POST /auth/login",
    "POST /historias",
    "POST /historias/cancelMiHistoria",
]

export const bloqueadoEnDemo = (method, uri) => {
    if (!EN_DEMO) return false
    if (method === "GET") return false
    return !ESCRITURAS_PERMITIDAS.includes(`${method} ${uri}`)
}

// Panel de acceso rápido: en dev y demo, nunca en prod. Las cuentas de prueba llegan por
// config.js desde el .env del entorno (CUENTAS_PRUEBA): no viajan en el bundle, y el
// .prod.env no las trae. Ver control-room/harness/conventions/comportamiento-por-entorno.md
export const CUENTAS_DEMO = Array.isArray(config.cuentasPrueba) ? config.cuentasPrueba : []

// El panel "Ingresar como" aparece donde hay cuentas que mostrar.
export const MOSTRAR_LOGIN_RAPIDO = CUENTAS_DEMO.length > 0
